import { ArticleBatchDto } from '../../../../shared/dto/article-batch.dto';
import { AfterViewInit, Component, ElementRef, EventEmitter, inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzInputDirective, NzInputGroupComponent, NzInputGroupWhitSuffixOrPrefixDirective } from 'ng-zorro-antd/input';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef, NzModalService, NzModalTitleDirective } from 'ng-zorro-antd/modal';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzTableCellDirective, NzTableComponent, NzTbodyComponent, NzTheadComponent, NzThMeasureDirective, NzTrDirective } from 'ng-zorro-antd/table';
import { Subject, takeUntil } from 'rxjs';
import { TITLE_TABLE_SIZE } from 'src/app/core/constants/style';
import { ArticleBatchesService } from 'src/app/private/services/article-batches.service';
import { ArticlesService } from 'src/app/private/services/articles.service';
import { PackagingsService } from 'src/app/private/services/packagings.service';
import { ArticleDto } from 'src/app/shared/dto/article.dto';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { PermissionService } from 'src/app/core/services/permission.service';
import { UserDto } from 'src/app/shared/dto/user.dto';
import { UserLoggedService } from 'src/app/core/services/userLogged.service';
import { ProductionOrderProcessDto } from 'src/app/shared/dto/production-order-process.dto';
import { ProductionOrderProcessesService } from 'src/app/private/services/production-order-processes.service';
import { RawMaterialDto } from 'src/app/shared/dto/rawMaterial.dto';
import { ModalRawMaterialEditionComponent } from '../modal-raw-material-edition/modal-raw-material-edition.component';
import { ModalSearchArticlesComponent } from '../modal-search-articles/modal-search-articles.component';
import { MODAL_HEIGHT_LEVEL_2, MODAL_TOP_LEVEL_2, MODAL_WIDTH_LEVEL_2 } from 'src/app/core/constants/components';
import _ from 'lodash';
import { ArticleSearchResponseDto } from 'src/app/shared/dto/pagination/articles-search-response.dto';

@Component({
    selector: 'app-modal-used-raw-materials',
    templateUrl: './modal-used-raw-materials.component.html',
    styleUrls: ['./modal-used-raw-materials.component.scss'],
    standalone: true,
    imports: [
        NzTableComponent,
        NzTheadComponent,
        NzTrDirective,
        NzModalTitleDirective,
        NzTableCellDirective,
        NzThMeasureDirective,
        NzTbodyComponent,
        ReactiveFormsModule,
        FormsModule,
        NzModalFooterDirective,
        NzMessageModule,
        NzSelectModule,
        NzIconModule,
        NzToolTipModule,
        NzEmptyModule,
        LoaderComponent,
        NzButtonModule
    ]
})

export class ModalUsedRawMaterialsComponent implements OnInit, OnDestroy, AfterViewInit {
    @Output() emitService = new EventEmitter();
    @ViewChild('modalContent') private readonly _modalContent!: ElementRef;
    @ViewChild('myInput') myInputRef!: ElementRef<HTMLInputElement>;

    isLoading: boolean = true;
    isSaving: boolean = false;
    articles: ArticleDto[] = [];
    articleBatches: ArticleBatchDto[] = [];
    articlesAndBatches: any = [];
    tableHeight!: number;
    canCreate: boolean;
    canEdit: boolean;
    canDelete: boolean;
    isFromOrderProcessDetail: boolean;
    orderProcess: ProductionOrderProcessDto;
    textAreaBatchSearchValue: string = '';

    readonly nzModalData = inject(NZ_MODAL_DATA);

    private loggedUser: UserDto = new UserDto();

    private readonly unsubscribe$ = new Subject();

    private readonly articleService = inject(ArticlesService);
    private readonly articleBatchService = inject(ArticleBatchesService);
    private readonly packagingsService = inject(PackagingsService);
    private readonly modalRef = inject(NzModalRef);
    private readonly message = inject(NzMessageService);
    private readonly permissionService = inject(PermissionService);
    private readonly userLoggedService = inject(UserLoggedService);
    private readonly modalService = inject(NzModalService);
    private readonly productionOrderProcessesService = inject(ProductionOrderProcessesService);

    constructor() {
        const permissionMainKey: string = 'productionOrderProcessDetail';
        const btnName: string = 'btnWatchRawMaterialToUse';

        this.modalRef.afterOpen.subscribe(() => {
            setTimeout(() => {
                if (this.myInputRef?.nativeElement) {
                    this.myInputRef.nativeElement.focus();
                } else {
                    console.warn('myInputRef o nativeElement no está disponible al intentar enfocar');
                }
            }, 0);
        });

        this.loggedUser = this.userLoggedService.userLogged;
        this.orderProcess = this.nzModalData?.orderProcess;
        this.isFromOrderProcessDetail = this.nzModalData.isFromOrderProcessDetail ?? false;
        this.canCreate = this.permissionService.canEdit(permissionMainKey, `${btnName}`);
        this.canEdit = this.permissionService.canEdit(permissionMainKey, `${btnName}`);
        this.canDelete = this.permissionService.canDelete(permissionMainKey, `${btnName}`);
    }

    async ngOnInit() {
        if ((this.canCreate && this.canEdit && this.isFromOrderProcessDetail) || !this.isFromOrderProcessDetail) {
            await this.articleService.setupWebSocket();
            this.articleService.articles$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: (articles) => {
                        this.articles = articles;
                    },
                    error: () => {
                        this.message.error('No se han podido cargar los artículos.');
                    }
                });

            await this.articleBatchService.setupWebSocket();
            this.articleBatchService.articleBatches$
                .pipe(takeUntil(this.unsubscribe$))
                .subscribe({
                    next: (articleBatches) => {
                        this.articleBatches = articleBatches;
                    },
                    error: () => {
                        this.message.error('No se han podido cargar los lotes de artículos.');
                    }
                });
        }

        this.isLoading = false;
    }

    async ngAfterViewInit(): Promise<void> {
        setTimeout(() => {
            this.tableHeight =
                (this._modalContent.nativeElement as HTMLImageElement)
                    .clientHeight - (TITLE_TABLE_SIZE + 20);

            console.log(this.tableHeight);
        });
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next({});
        this.unsubscribe$.complete();
        if ((this.canCreate && this.canEdit && this.isFromOrderProcessDetail) || !this.isFromOrderProcessDetail) {
            this.articleService.disconnectWebSocket();
            this.articleBatchService.disconnectWebSocket();
            this.packagingsService.disconnectWebSocket();
        }
    }

    compareById(o1: any, o2: any): boolean {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    }

    compareByObject(o1: any, o2: any): boolean {
        return o1 === o2;
    }

    compareByBatchNumber = (o1: ArticleBatchDto, o2: ArticleBatchDto): boolean => {
        return o1 && o2 ? o1.batchNumber === o2.batchNumber : o1 === o2;
    };

    compareByPackagingElementId = (o1: any, o2: any): boolean => {
        return o1 && o2 ? o1.id === o2.id : o1 === o2;
    };

    filterArticlesSelector(searchValue: string, article: any): boolean {
        if (!searchValue) {
            return true;
        }
        const lowerCaseSearch = searchValue.toLowerCase();
        return (
            article.nzValue.name?.toLowerCase().includes(lowerCaseSearch) ||
            article.nzValue.externalId?.toString().toLowerCase().includes(lowerCaseSearch) ||
            article.nzValue.ean?.toLowerCase().includes(lowerCaseSearch)
        );
    }

    filterArticleBatchesSelector = (searchValue: string, batch: any): boolean => {
        if (!searchValue) {
            return true;
        }
        const lowerCaseSearch = searchValue.toLowerCase();
        return (
            batch.nzValue.batchNumber?.toString().toLowerCase().includes(lowerCaseSearch) ||
            batch.nzValue.externalId?.toString().toLowerCase().includes(lowerCaseSearch)
        );
    };

    filterPackagingOnArticleBatchSelector = (searchValue: string, packaging: any): boolean => {
        if (!searchValue) {
            return true;
        }
        const lowerCaseSearch = searchValue.toLowerCase();
        return (
            packaging.nzValue.packagingBatchExternalId?.toString().toLowerCase().includes(lowerCaseSearch) ||
            packaging.nzValue.externalBatchNumber?.toLowerCase().includes(lowerCaseSearch)
        );
    };

    handleCancel() {
        this.modalRef.close();
    }

    isDisabled(createdById: number | undefined): boolean {
        if (createdById) {
            return createdById != this.loggedUser.id;
        }

        return true;
    }

    async editRawMaterial(rawMaterial: RawMaterialDto) {
        const modal = this.modalService.create({
            nzContent: ModalRawMaterialEditionComponent,
            nzStyle: { width: '30%', top: '15%' },
            nzBodyStyle: { height: '50vh' },
            nzClosable: false,
            nzKeyboard: false,
            nzFooter: null,
            nzMaskClosable: false,
            nzData: {
                nzTitle: `Editar materia prima ${rawMaterial.id}- Proceso ${this.orderProcess?.id} | ${this.orderProcess?.description}`,
                rawMaterial: rawMaterial
            }
        });

        modal.componentInstance?.emitService.subscribe(async (edittedRawMaterial: RawMaterialDto) => {
            if (!edittedRawMaterial) {
                this.orderProcess.rawMaterialsUsed = _.cloneDeep(this.orderProcess.rawMaterialsUsed.filter(rm => rm.id != rawMaterial.id));
            } else {
                const rawMaterialToUpdateIndex: number = this.orderProcess.rawMaterialsUsed.findIndex(rw => rw.id === edittedRawMaterial.id);

                if (rawMaterialToUpdateIndex > 0) {
                    this.orderProcess.rawMaterialsUsed[rawMaterialToUpdateIndex].rawQuantity = edittedRawMaterial.rawQuantity;
                } else {
                    this.orderProcess.rawMaterialsUsed.push(edittedRawMaterial);
                }

                const updatedOrderProcess: ProductionOrderProcessDto = await this.productionOrderProcessesService.updateRawMaterialsUsed(this.orderProcess.id!, this.orderProcess.rawMaterialsUsed);

                this.orderProcess.rawMaterialsUsed = _.cloneDeep(updatedOrderProcess.rawMaterialsUsed);
                this.message.success(`Materia prima actualizada correctamente`);
            }

            modal.close();
        });
    }
}
